var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLength = function SvgLength(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.479 2.35v.375zm8.148 0v-.375zm.374.375h-.374zm0 8.149h-.375zM3.367 5.45a.375.375 0 0 0-.53 0L.45 7.837a.375.375 0 1 0 .53.53l2.122-2.121 2.12 2.121a.375.375 0 1 0 .531-.53zm-.638-1.428a.375.375 0 1 0 .75 0zm.75-1.297h8.148v-.75H3.479zm8.148 0-.001 8.149h.75v-8.15zm-.001 8.149h-8.15v.75h8.15zm-8.15 0V5.716h-.75v5.158zm-.747-8.15v1.298h.75V2.725zm.748 8.15h-.75c0 .414.335.75.75.75zm8.149 0v.75a.75.75 0 0 0 .75-.75zm0-8.15h.75a.75.75 0 0 0-.75-.75zm-8.147-.75a.75.75 0 0 0-.75.75h.75z"
  })));
};
export default SvgLength;